if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      async getCart() {
        const res = await fetch(`${routes.cart_url}.js`)
        const parsedRes = await res.json()
        return parsedRes
      }

      async onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        try {
          if (this.dataset.isMembershipProduct === 'true') {
            const cart = await this.getCart()
            // NOTE: if more membership products are added later, update this logic if necessary (e.g. check for properties[_membership_product] if only one is allowed in the cart)
            const isMembershipInCart = cart.items.some((item) => item.product_id === Number(formData.get('product-id')))
            if (isMembershipInCart) {
              this.handleErrorMessage('You already have this membership in your cart.')
              return
            }
          }

          const fetchRes = await fetch(routes.cart_add_url, config)
          const response = await fetchRes.json()
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            })
            this.handleErrorMessage(response.description)

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          } else if (!this.cart) {
            window.location = window.routes.cart_url
            return
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            })
          }
          this.error = false
          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response)
                })
              },
              { once: true }
            )
            quickAddModal.hide(true)
          } else {
            this.cart.renderContents(response)
          }
        } catch (err) {
          console.error(e)
        } finally {
          this.submitButton.classList.remove('loading')
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          this.querySelector('.loading-overlay__spinner').classList.add('hidden')
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
